import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/(agent)')({
    component: AgentLayout,
});

function AgentLayout() {
    return <Outlet />;
}
